// Laboon fallback (only arc without a downloaded image)
const laboonImage = 'https://cdn.myanimelist.net/images/characters/13/235377.jpg';

const storyArcs = [
  {
    saga: 'East Blue Saga',
    sagaType: 'first-half',
    arcs: [
      { name: 'Romance Dawn', slug: 'romance-dawn', chapters: '1-7', episodes: '1-3', filler: false, image: '/arcs/romance-dawn.webp', desc: 'Luffy sets out from his home village to become the Pirate King.' },
      { name: 'Orange Town', slug: 'orange-town', desc: 'Luffy fights Buggy the Clown and recruits Nami.', chapters: '8-21', episodes: '4-8', filler: false, image: '/arcs/orange-town.webp' },
      { name: 'Syrup Village', slug: 'syrup-village', desc: 'Usopp joins the crew after they defeat Captain Kuro.', chapters: '22-41', episodes: '9-18', filler: false, image: '/arcs/syrup-village.webp' },
      { name: 'Baratie', slug: 'baratie', desc: 'Sanji joins the crew at the floating restaurant. Mihawk appears.', chapters: '42-68', episodes: '19-30', filler: false, image: '/arcs/baratie.webp' },
      { name: 'Arlong Park', slug: 'arlong-park', desc: 'Luffy destroys Arlong Park and frees Nami\'s village.', chapters: '69-95', episodes: '31-44', filler: false, image: '/arcs/arlong-park.webp' },
      { name: 'Loguetown', slug: 'loguetown', desc: 'The crew visits the town where Roger was executed. Smoker appears.', chapters: '96-100', episodes: '45, 48-53', filler: false, image: '/arcs/loguetown.webp' },
    ]
  },
  {
    saga: 'Arabasta Saga',
    sagaType: 'first-half',
    arcs: [
      { name: 'Reverse Mountain', slug: 'reverse-mountain', desc: 'The crew enters the Grand Line and meets Laboon.', chapters: '101-105', episodes: '62-63', filler: false, image: laboonImage },
      { name: 'Whisky Peak', slug: 'whisky-peak', desc: 'Zoro fights 100 bounty hunters. Vivi\'s identity is revealed.', chapters: '106-114', episodes: '64-67', filler: false, image: '/arcs/whisky-peak.webp' },
      { name: 'Little Garden', slug: 'little-garden', desc: 'The crew meets two giants who have been dueling for 100 years.', chapters: '115-129', episodes: '70-77', filler: false, image: '/arcs/little-garden.webp' },
      { name: 'Drum Island', slug: 'drum-island', desc: 'Chopper joins the crew after Wapol is defeated.', chapters: '130-154', episodes: '78-91', filler: false, image: '/arcs/drum-island.webp' },
      { name: 'Arabasta', slug: 'arabasta', desc: 'The crew helps Vivi save her kingdom from Crocodile.', chapters: '155-217', episodes: '92-130', filler: false, image: '/arcs/arabasta.webp' },
    ]
  },
  {
    saga: 'Sky Island Saga',
    sagaType: 'first-half',
    arcs: [
      { name: 'Jaya', slug: 'jaya', desc: 'The crew searches for Skypiea. Luffy punches Bellamy.', chapters: '218-236', episodes: '144-152', filler: false, image: '/arcs/jaya.webp' },
      { name: 'Skypiea', slug: 'skypiea', desc: 'The crew reaches the sky island and fights the god Enel.', chapters: '237-302', episodes: '153-195', filler: false, image: '/arcs/skypiea.webp' },
    ]
  },
  {
    saga: 'Water 7 Saga',
    sagaType: 'first-half',
    arcs: [
      { name: 'Long Ring Long Land', slug: 'long-ring-long-land', desc: 'The Davy Back Fight against the Foxy Pirates.', chapters: '303-321', episodes: '207-219', filler: false, image: '/arcs/long-ring.webp' },
      { name: 'Water 7', slug: 'water-7', desc: 'Robin is taken by CP9. The Going Merry can no longer sail.', chapters: '322-374', episodes: '229-263', filler: false, image: '/arcs/water-7.webp' },
      { name: 'Enies Lobby', slug: 'enies-lobby', desc: 'The crew invades the judicial island to rescue Robin.', chapters: '375-430', episodes: '264-312', filler: false, image: '/arcs/enies-lobby.webp' },
      { name: 'Post-Enies Lobby', slug: 'post-enies-lobby', desc: 'Franky builds the Thousand Sunny and joins the crew.', chapters: '431-441', episodes: '313-325', filler: false, image: '/arcs/post-enies.webp' },
    ]
  },
  {
    saga: 'Thriller Bark Saga',
    sagaType: 'first-half',
    arcs: [
      { name: 'Thriller Bark', slug: 'thriller-bark', desc: 'The crew fights Gecko Moria and his zombie army. Brook joins.', chapters: '442-489', episodes: '337-381', filler: false, image: '/arcs/thriller-bark.webp' },
    ]
  },
  {
    saga: 'Summit War Saga',
    sagaType: 'first-half',
    arcs: [
      { name: 'Sabaody Archipelago', slug: 'sabaody-archipelago', desc: 'The crew meets the Supernovas. Kuma separates the Straw Hats.', chapters: '490-513', episodes: '385-405', filler: false, image: '/arcs/sabaody.webp' },
      { name: 'Amazon Lily', slug: 'amazon-lily', desc: 'Luffy lands on the island of women and meets Boa Hancock.', chapters: '514-524', episodes: '408-417', filler: false, image: '/arcs/amazon-lily.webp' },
      { name: 'Impel Down', slug: 'impel-down', desc: 'Luffy breaks into the underwater prison to save Ace.', chapters: '525-549', episodes: '422-425, 430-452', filler: false, image: '/arcs/impel-down.webp' },
      { name: 'Marineford', slug: 'marineford', desc: 'The war between the Marines and Whitebeard Pirates. Ace dies.', chapters: '550-580', episodes: '457-489', filler: false, image: '/arcs/marineford.webp' },
      { name: 'Post-War', slug: 'post-war', desc: 'Luffy recovers. The crew begins their two-year training.', chapters: '581-597', episodes: '490-516', filler: false, image: '/arcs/post-war.webp' },
    ]
  },
  {
    saga: 'Fish-Man Island Saga',
    sagaType: 'second-half',
    arcs: [
      { name: 'Return to Sabaody', slug: 'return-to-sabaody', desc: 'The Straw Hats reunite after two years of training.', chapters: '598-602', episodes: '517-522', filler: false, image: '/arcs/return-sabaody.webp' },
      { name: 'Fish-Man Island', slug: 'fish-man-island', desc: 'The crew travels underwater to Fish-Man Island.', chapters: '603-653', episodes: '523-574', filler: false, image: '/arcs/fishman-island.webp' },
    ]
  },
  {
    saga: 'Dressrosa Saga',
    sagaType: 'second-half',
    arcs: [
      { name: 'Punk Hazard', slug: 'punk-hazard', desc: 'The crew allies with Law to take down Doflamingo.', chapters: '654-699', episodes: '579-625', filler: false, image: '/arcs/punk-hazard.webp' },
      { name: 'Dressrosa', slug: 'dressrosa', desc: 'Luffy defeats Doflamingo and frees Dressrosa. The Grand Fleet forms.', chapters: '700-801', episodes: '629-746', filler: false, image: '/arcs/dressrosa.webp' },
    ]
  },
  {
    saga: 'Whole Cake Island Saga',
    sagaType: 'second-half',
    arcs: [
      { name: 'Zou', slug: 'zou', desc: 'The crew reaches the elephant island and learns about the Road Poneglyphs.', chapters: '802-824', episodes: '751-779', filler: false, image: '/arcs/zou.webp' },
      { name: 'Whole Cake Island', slug: 'whole-cake-island', desc: 'Sanji\'s wedding. Luffy fights Katakuri. Jinbe officially joins.', chapters: '825-902', episodes: '783-877', filler: false, image: '/arcs/whole-cake.webp' },
    ]
  },
  {
    saga: 'Wano Country Saga',
    sagaType: 'second-half',
    arcs: [
      { name: 'Reverie', slug: 'reverie', desc: 'World leaders meet at Mariejois. Sabo is framed for a crime.', chapters: '903-908', episodes: '878-889', filler: false, image: '/arcs/reverie.webp' },
      { name: 'Wano Country', slug: 'wano-country', desc: 'The alliance raids Onigashima. Luffy awakens Gear Fifth and defeats Kaido.', chapters: '909-1057', episodes: '890-1085', filler: false, image: '/arcs/wano.webp' },
    ]
  },
  {
    saga: 'Final Saga',
    sagaType: 'second-half',
    arcs: [
      { name: 'Egghead', slug: 'egghead', desc: 'The crew visits Vegapunk\'s island. Major world secrets are revealed.', chapters: '1058-1125', episodes: '1086-1155', filler: false, image: '/arcs/egghead.webp' },
      { name: 'Elbaph', slug: 'elbaph', desc: 'The crew arrives at the land of giants. The current arc.', chapters: '1126-ongoing', episodes: '1156-ongoing', filler: false, image: '/arcs/elbaph.webp' },
    ]
  },
];

export default storyArcs;
